var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmojiGood = function SvgEmojiGood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 18c0-9.941-8.059-18-18-18S0 8.059 0 18s8.059 18 18 18 18-8.059 18-18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M35 18c0-9.389-7.611-17-17-17S1 8.611 1 18s7.611 17 17 17 17-7.611 17-17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.382 22.498a.86.86 0 0 1 .472-1.1.85.85 0 0 1 1.1.446c.08.184 1.81 4.118 7.372 4.118 5.614 0 7.372-4.092 7.372-4.118a.885.885 0 0 1 1.1-.473.886.886 0 0 1 .472 1.1c-.078.237-2.2 5.195-8.946 5.195-6.71.001-8.836-4.957-8.942-5.168m15.61-6.585a1.824 1.824 0 0 1-1.837-1.837v-1.443a1.824 1.824 0 0 1 1.836-1.836h.026a1.825 1.825 0 0 1 1.837 1.836v1.443a1.826 1.826 0 0 1-1.837 1.837zm-13.328 0a1.824 1.824 0 0 1-1.836-1.837v-1.443a1.824 1.824 0 0 1 1.836-1.836h.026a1.824 1.824 0 0 1 1.837 1.836v1.443a1.83 1.83 0 0 1-1.837 1.837z"
  })));
};
export default SvgEmojiGood;